import type { ReactNode } from 'react'
import DrawerAskAIFooter from 'tripPlanner/components/DrawerAskAI/DrawerAskAIFooter'
import {
  useTripDrawerPresentation,
  type TripDrawerPresentation,
} from 'tripPlanner/components/GenericDrawer/TripDrawerPresentationContext'
import DrawerAskAIContextActivator from './DrawerAskAIContextActivator'

interface TripDrawerAssistantContextProps {
  isOpen: boolean
  presentation: TripDrawerPresentation
  contextLabel?: string
  contextDetails?: string
}

interface TripDrawerAssistantFooterProps
  extends TripDrawerAssistantContextProps {
  fallback?: ReactNode
  placeholder?: string
}

export function TripDrawerAssistantFooter({
  isOpen,
  presentation,
  contextLabel,
  contextDetails,
  fallback,
  placeholder,
}: TripDrawerAssistantFooterProps) {
  const { portalElement } = useTripDrawerPresentation()
  const isRightPanelMounted = presentation === 'right-panel' && !!portalElement

  if (isRightPanelMounted || !isOpen || !contextLabel) {
    return fallback ?? null
  }

  return (
    <DrawerAskAIFooter
      contextLabel={contextLabel}
      isOpen={isOpen}
      contextDetails={contextDetails}
      placeholder={placeholder}
    />
  )
}

function TripDrawerAssistantBridge({
  isOpen,
  presentation,
  contextLabel,
  contextDetails,
}: TripDrawerAssistantContextProps) {
  const { portalElement } = useTripDrawerPresentation()
  const isRightPanelMounted = presentation === 'right-panel' && !!portalElement

  if (!isRightPanelMounted) return null

  return (
    <DrawerAskAIContextActivator
      isOpen={isOpen}
      contextLabel={contextLabel}
      contextDetails={contextDetails}
    />
  )
}

export default TripDrawerAssistantBridge
